// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_96d72f93","outerContainer":"cc9e8232","secondaryToolbar":"_36aa8524","doorHangerRight":"ed90fe8c","toolbarContainer":"_5935c591","toolbarViewerMiddle":"_0d0f9019","progressBar":"c974b411","back-to-application":"f7288db2","Report":"ea420eda","ReportLogo":"_4a6a46be","ReportWrapper":"_58f99238","ReportBody":"_93d7e9cc","ReportActions":"_52521187","ReportTitle":"_28805891","ReportText":"_405554ea","ReportInfo":"_4e27e6f3","ReportInfo-item":"_0579b14e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Communities/Reports/ReportItem/styles.styl
// module id = 4933
// module chunks = 39